import { useMutation, useQueryClient } from '@tanstack/react-query';
import useHttpClient from './useHttpClient';
import { IProject } from './models/project';

export interface IProjectDataReq {
  projectTypeId: { native: number; };
  clientId: { native: number; };
  projectName?: string;
}

interface UseCreateProjectOptions {
  onSuccess?: (project: IProject) => void;
  onError?: (error: Error) => void;
}

const useCreateProject = (options?: UseCreateProjectOptions) => {
  const httpClient = useHttpClient();
  const queryClient = useQueryClient();

  return useMutation<IProject, Error, IProjectDataReq>({
    mutationFn: async (projectData: IProjectDataReq) => {
      const response = await httpClient.post('/projects', projectData);
      return response.data;
    },
    onSuccess: (newProject) => {
      queryClient.invalidateQueries({ queryKey: ['projects'] });

      if (options?.onSuccess) {
        options.onSuccess(newProject);
      }
    },
    onError: (error) => {
      console.error('Failed to create project:', error);
      // Call the component's onError callback
      if (options?.onError) {
        options.onError(error);
      }
    },
  });
};

export default useCreateProject;
